module.exports = __webpack_public_path__ + "static/media/simran_kucheria.c574101b.jpeg";